import { Select } from '@nike/eds';
const channelOptions = [
  { value: '82a74ac1-c527-4470-b7b0-fb5f3ef3c2e2', label: 'Nike App' },
  { value: 'd9a5bc42-4b9c-4976-858a-f159cf99c647', label: 'Nike.COM' },
  { value: '15d92135-394e-487a-8afa-f6c8525c9ea9', label: 'WeChat' },
  { value: '008be467-6c78-4079-94f0-70e2d6cc4003', label: 'SNKRS' },
];

export function Channel(params: any) {
  return (
    <Select
      id='channel-select'
      className='tw-w-60 tw-rounded-3xl'
      label='Channel'
      options={channelOptions}
      value={channelOptions.find((v) => v.value === params.consumerChannelId)}
      onChange={(event) => {
        params.setConsumerChannelId(event?.value || '');
      }}
    />
  );
}
